import analyticsUtils from './Analytics.utils'
/* eslint-disable */

const enable = GLOBAL_ENV.TYPE === 'browser' && GLOBAL_ENV.NODE_ENV === 'production' 

export default () => {
  if (enable) {
    // We load the standard segment analytics
    // This is used for non essential things like Google tag manager, Facebook Pixel etc
    // Other events are tracked server-side.
    const analytics = window.analytics = window.analytics || []; if (!analytics.initialize) {
      if (analytics.invoked)window.console && console.error && console.error('Segment snippet included twice.'); else { 
        analytics.invoked = !0; analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on']; analytics.factory = function (t) { return function () { const e = Array.prototype.slice.call(arguments); e.unshift(t); analytics.push(e); return analytics } }; for (let t = 0; t < analytics.methods.length; t++) { const e = analytics.methods[t]; analytics[e] = analytics.factory(e) }analytics.load = function (t, e) { const n = document.createElement('script'); n.type = 'text/javascript'; n.async = !0; n.src = `https://cdn.segment.com/analytics.js/v1/${t}/analytics.min.js`; const a = document.getElementsByTagName('script')[0]; a.parentNode.insertBefore(n, a); analytics._loadOptions = e }; analytics.SNIPPET_VERSION = '4.1.0'
        analytics.load('ckvW8DcUBfMLoHmAlZNxgpbmoPUhBET3')
        analytics.ready(() => {
          analyticsUtils.identify({})
          analyticsUtils.page()
        })
      } 
    }
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Analytics/Analytics.init.js